import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const TeamsColor = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      id="Vector"
      d="M7.43754 4.66667C8.5651 4.66667 9.47923 3.75259 9.47923 2.62501C9.47923 1.49743 8.5651 0.583344 7.43754 0.583344C6.30996 0.583344 5.39587 1.49743 5.39587 2.62501C5.39587 3.75259 6.30996 4.66667 7.43754 4.66667Z"
      fill="#7B83EB"
    />
    <path
      id="Vector_2"
      opacity="0.1"
      d="M7.29152 3.0625H5.44287C5.44583 3.07612 5.44894 3.08972 5.45219 3.1033L5.45301 3.10672C5.45601 3.11922 5.45918 3.13169 5.46239 3.14413C5.59674 3.65364 5.92271 4.09157 6.37224 4.36648C6.82177 4.64139 7.36012 4.73204 7.8749 4.61949V3.64582C7.87441 3.49125 7.81281 3.34314 7.70354 3.23385C7.5942 3.12455 7.44608 3.06295 7.29152 3.0625Z"
      fill="black"
    />
    <path
      id="Vector_3"
      opacity="0.2"
      d="M6.85412 3.5H5.59241C5.75803 3.84912 6.01933 4.14408 6.34594 4.3506C6.67255 4.55711 7.05107 4.66671 7.43747 4.66665V4.08332C7.43705 3.92875 7.37538 3.78064 7.26611 3.67135C7.15684 3.56205 7.00872 3.50045 6.85412 3.5Z"
      fill="black"
    />
    <path
      id="Vector_4"
      d="M12.0312 4.8125C12.8769 4.8125 13.5625 4.12693 13.5625 3.28125C13.5625 2.43557 12.8769 1.75 12.0312 1.75C11.1856 1.75 10.5 2.43557 10.5 3.28125C10.5 4.12693 11.1856 4.8125 12.0312 4.8125Z"
      fill="#5059C9"
    />
    <path
      id="Vector_5"
      d="M13.3436 5.25H9.90455C9.83035 5.25 9.75923 5.27946 9.7068 5.33189C9.65437 5.38432 9.6249 5.45544 9.6249 5.52959V9.07781C9.61538 9.59133 9.78261 10.0925 10.0984 10.4975C10.4144 10.9024 10.8598 11.1866 11.3601 11.3023C11.6789 11.3693 12.0085 11.3642 12.325 11.2876C12.6415 11.211 12.937 11.0648 13.1899 10.8596C13.4428 10.6544 13.6467 10.3954 13.7868 10.1014C13.927 9.80735 13.9998 9.48584 13.9999 9.1602V5.90625C13.9999 5.7322 13.9307 5.56529 13.8077 5.44222C13.6846 5.31915 13.5177 5.25001 13.3436 5.25Z"
      fill="#5059C9"
    />
    <path
      id="Vector_6"
      d="M10.9375 5.90625V10.0625C10.938 10.8328 10.6842 11.5817 10.2155 12.193C9.74687 12.8043 9.0895 13.2437 8.34554 13.4432C7.60151 13.6427 6.81248 13.591 6.10087 13.2961C5.38926 13.0012 4.79489 12.4797 4.41 11.8125C4.32581 11.6726 4.25268 11.5263 4.19125 11.375C4.13399 11.2323 4.08577 11.0863 4.04688 10.9375C3.97475 10.6514 3.93802 10.3576 3.9375 10.0625V5.90625C3.93739 5.82004 3.95428 5.73465 3.98722 5.65498C4.02016 5.5753 4.06849 5.50292 4.12945 5.44195C4.19042 5.38099 4.2628 5.33266 4.34248 5.29972C4.42215 5.26678 4.50754 5.24989 4.59375 5.25H10.2813C10.3675 5.24989 10.4528 5.26678 10.5326 5.29972C10.6122 5.33266 10.6846 5.38099 10.7456 5.44195C10.8065 5.50292 10.8548 5.5753 10.8878 5.65498C10.9207 5.73465 10.9376 5.82004 10.9375 5.90625Z"
      fill="#7B83EB"
    />
    <path
      id="Vector_7"
      opacity="0.2"
      d="M6.85412 3.5H5.59241C5.75803 3.84912 6.01933 4.14408 6.34594 4.3506C6.67255 4.55711 7.05107 4.66671 7.43747 4.66665V4.08332C7.43705 3.92875 7.37538 3.78064 7.26611 3.67135C7.15684 3.56205 7.00872 3.50045 6.85412 3.5Z"
      fill="black"
    />
    <path
      id="Vector_8"
      opacity="0.1"
      d="M7.875 5.25V10.7931C7.875 10.925 7.82985 11.0529 7.74704 11.1556C7.6643 11.2582 7.54887 11.3295 7.42 11.3575C7.37884 11.3698 7.33607 11.3756 7.29309 11.375H4.19125C4.13399 11.2323 4.08577 11.0863 4.04688 10.9375C3.97475 10.6514 3.93802 10.3576 3.9375 10.0625V5.90625C3.93739 5.82004 3.95428 5.73465 3.98722 5.65498C4.02016 5.5753 4.06849 5.50292 4.12945 5.44195C4.19042 5.38099 4.2628 5.33266 4.34248 5.29972C4.42215 5.26678 4.50754 5.24989 4.59375 5.25H7.875Z"
      fill="black"
    />
    <path
      id="Vector_9"
      opacity="0.2"
      d="M7.4375 5.25V11.2306C7.43813 11.2736 7.43225 11.3163 7.42 11.3575C7.392 11.4864 7.32074 11.6018 7.21805 11.6845C7.11543 11.7674 6.98751 11.8125 6.85563 11.8125H4.41C4.32581 11.6726 4.25268 11.5263 4.19125 11.375C4.13399 11.2323 4.08577 11.0863 4.04688 10.9375C3.97475 10.6514 3.93802 10.3576 3.9375 10.0625V5.90625C3.93739 5.82004 3.95428 5.73465 3.98722 5.65498C4.02016 5.5753 4.06849 5.50292 4.12945 5.44195C4.19042 5.38099 4.2628 5.33266 4.34248 5.29972C4.42215 5.26678 4.50754 5.24989 4.59375 5.25H7.4375Z"
      fill="black"
    />
    <path
      id="Vector_10"
      opacity="0.2"
      d="M7.4375 5.25V10.3556C7.4368 10.5097 7.37527 10.6574 7.26635 10.7664C7.15736 10.8753 7.00973 10.9368 6.85563 10.9375H4.04688C3.97475 10.6514 3.93802 10.3576 3.9375 10.0625V5.90625C3.93739 5.82004 3.95428 5.73465 3.98722 5.65498C4.02016 5.5753 4.06849 5.50292 4.12945 5.44195C4.19042 5.38099 4.2628 5.33266 4.34248 5.29972C4.42215 5.26678 4.50754 5.24989 4.59375 5.25H7.4375Z"
      fill="black"
    />
    <path
      id="Vector_11"
      opacity="0.2"
      d="M4.59375 5.25C4.50754 5.24989 4.42215 5.26678 4.34248 5.29972C4.2628 5.33266 4.19042 5.38099 4.12945 5.44195C4.06849 5.50292 4.02016 5.5753 3.98722 5.65498C3.95428 5.73465 3.93739 5.82004 3.9375 5.90625V10.0625C3.93802 10.3576 3.97475 10.6514 4.04688 10.9375H6.41813C6.57224 10.9368 6.71985 10.8753 6.82882 10.7664C6.9378 10.6574 6.99932 10.5097 7 10.3556V5.25H4.59375Z"
      fill="black"
    />
    <path
      id="Vector_12"
      d="M0.583332 3.5H6.41668C6.57138 3.5 6.71976 3.56147 6.82915 3.67086C6.93855 3.78026 7 3.92863 7 4.08334V9.91669C7 10.0714 6.93855 10.2197 6.82915 10.3291C6.71976 10.4385 6.57139 10.5 6.41668 10.5H0.583336C0.428625 10.5 0.280252 10.4385 0.170855 10.3291C0.0614583 10.2197 0 10.0714 0 9.91669V4.08333C0 3.92862 0.0614583 3.78025 0.170854 3.67086C0.28025 3.56146 0.428623 3.5 0.583332 3.5Z"
      fill="#4B53BC"
    />
    <path
      id="Vector_13"
      d="M5.23798 5.67609H3.93282V9.18499H3.07505V5.67609H1.76233V4.81406H5.23798V5.67609Z"
      fill="white"
    />
  </Icon>
));

export default TeamsColor;
